module.exports = __webpack_public_path__ + "img/xrplorg-consensus.4f189732.gif";